import { axiosInstance as Axios } from "@/main";
import { reject } from "core-js/fn/promise";

export default {
  state: {
    patients: []
  },
  mutations: {     
    set_patients(state, payload) {
      state.patients = payload;
    },
    update_patient(state, payload) {
      state.patients = state.patients.map(it =>
        it.id !== payload.patient.id ? it : payload.patientnew
      );
    },
    add_patient(state, payload) {
      state.patients = [
        ...state.patients,
        { ...payload.patient, deleted: true }
      ];
    },
    virtualremove_patient(state, payload) {
      state.patients = state.patients.map(it =>
        it.id === payload.patient.id ? { ...it, deleted: true } : it
      );
    },
    remove_patient(state, payload) {
      state.patients = state.patients.filter(
        it => it.id !== payload.patient.id
      );
    },
    unremove_patient(state, payload) {
      state.patients = state.patients.map(it =>
        it.id === payload.patient.id ? { ...it, deleted: false } : it
      );
    }
  },
  actions: {
    async alter_patient(store, payload) {
      try {
        let response = null;

        if (payload.titular) {
          response = await Axios.patch(
            `${payload.url}protected/me`,
            payload.patient,
            {
              headers: {
                Authorization: `Bearer ${store.rootState.User.token}`
              }
            }
          );

          store.commit("set_user", response.data);
          payload.action();
        } else {
          response = await Axios.patch(
            `${payload.url}protected/me/dependentes/${payload.patient.id}`,
            payload.patient,
            {
              headers: {
                Authorization: `Bearer ${store.rootState.User.token}`
              }
            }
          );
        }

        payload.patientnew = response.data;
        store.commit("update_patient", payload);
        payload.action();
      } catch (e) {
        console.error(e);
        payload.error(e);
      }
    },
    async new_patient(store, payload) {
     
        store.commit("add_patient", payload);
        let response = await Axios.post(
          `${payload.url}protected/me/dependentes`,
          payload.patient,
          {
            headers: {
              Authorization: `Bearer ${store.rootState.User.token}`
            }
          }
        );

        payload.patientnew = response.data;
        store.commit("update_patient", payload);

        let info = { ...payload.patientnew, stepId: 6 };
        store.commit("set_selected", info);
      
    },
    async remove_patient(store, payload) {
      try {
        store.commit("set_disabled", true);
        store.commit("virtualremove_patient", payload);
        store.commit("set_selected", { id: 5, nome: null, stepId: 6 });
        await Axios.delete(
          `${payload.url}protected/me/dependentes/${payload.patient.id}`,
          {
            headers: {
              Authorization: `Bearer ${store.rootState.User.token}`
            }
          }
        );
        payload.patient.deleted = false;
        store.commit("remove_patient", payload);
      } catch (e) {
        console.error(e);
        store.commit("unremove_patient", payload);
      }
    },
    async load_patients(store, payload) {
      try {
        let result = await Axios.get(`${payload.url}protected/me/dependentes`, {
          headers: {
            Authorization: `Bearer ${store.rootState.User.token}`
          }
        });
        store.commit("set_patients", [
          store.rootState.User.user,
          ...result.data
        ]);
      } catch (e) {
        store.commit("")
        console.error(e);
      }
    }
  },
  getters: {
    get_patients(state, _getters, rootState) {
      return state.patients.filter(item => {
        return (
          item.nome
            .toLowerCase()
            .indexOf(rootState.General.search.toLowerCase()) > -1
        );
      });
    }
  }
};
